import React, { useState } from 'react';
import Button from 'components/base/Button';
import ModalExcluirNFe from './ModalExcluirNFe';

interface BotaoExcluirNFeProps {
  emissaoId: string;
  nfeNumero: number;
  redirectAfterDelete?: boolean;
}

const BotaoExcluirNFe: React.FC<BotaoExcluirNFeProps> = ({ emissaoId, nfeNumero, redirectAfterDelete }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button variant="phoenix-danger" size="sm" onClick={() => setShow(true)}>
        Excluir Rascunho
      </Button>

      <ModalExcluirNFe
        show={show}
        onHide={() => setShow(false)}
        nfeId={emissaoId}
        nfeNumero={nfeNumero}
        redirectAfterDelete={redirectAfterDelete}
      />
    </>
  );
};

export default BotaoExcluirNFe;
